import React, { useEffect, useState } from 'react'
import { Domain } from '../ApiConfig'

export default function DonationCard({ donation }) {
    const [isOpen, setIsOpen] = useState(false);
    // "donationCategory": [],
    //         "_id": "663a21f76b2d762a983d2581",
    //         "donarMobileNumber": "7709433561",
    //         "donarName": "सदस्य का नाम",
    //         "donarAddress": "सदस्य का पतासदस्य का पता",
    //         "donarCity": "सदस्य का शहर",
    //         "donationAmount": 1000000,
    //         "donationReciveDate": "2024-05-08T00:00:00.000Z",
    //         "donationReciverMembershipCode": "MEM00050",
    //         "remark": "Remark/ रिमार्क Remark/ रिमार्क Remark/ रिमार्क",
    //         "donarPhoto": "public/AchivementPhotos/1715085813872-2815522048002083.webp",
    //         "eventPhoto1": "",
    //         "eventPhoto2": "",
    //         "entryMembershipCode": "MEM00100",
    //         "entryName": "श्री विशाल हिम्मतलालजी कामरिया",
    //         "entryDatetime": "2024-05-07T12:43:35.354Z",
    //         "createdAt": "2024-05-07T12:43:35.361Z",
    //         "updatedAt": "2024-05-07T12:43:35.361Z",
    //         "donationId": 2,
    //         "__v": 0
    //     },

    console.log(donation)
    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    // console.log(donation)
    return (
        <>
            <ViwePopup isOpen={isOpen} setIsOpen={setIsOpen} donation={donation} />

            <div className='h-100 m-2 min-w-[330px]     border-r-5 border   shadow-2xl bg-white text-black  ' >
                <div className={`membercardHeadin bg-[#1E3A8A]    mt-[-0.5px] px-4 py-1 text-center text-white font-bold `}>
                    {donation.donarName}
                </div>
                <div className="p-2 flex justify-center flex-col ">
                    <div className="  ">
                        <div className="flex min-w-0 gap-x-4 items-center ">
                            <img className="h-[3.5rem] ring-2 ring-orange-400 w-[3.5rem]  flex-none rounded-full bg-blue-400" src={`${Domain + donation.donarPhoto.replace(" ", "%20")}`} alt="" loading="lazy" />

                            <div className="min-w-0 flex-auto font-extrabold leading-6 ">
                                <p className="text-[15px] flex  font-bold tracking-tight text-gray-600">
                                    <span className=' w-[80px] me-2 flex justify-between'>तिथि  <span>: </span> </span>
                                    {new Date(donation?.entryDatetime).toDateString()}
                                </p>
                                <p className="text-[15px] flex text-start  font-bold tracking-tight text-gray-600">
                                    <span className=' w-[80px] me-2 flex justify-between'>दान राशि<span >:</span></span>
                                    {donation?.donationAmount}
                                </p>
                            </div>
                        </div>
                        <div className=' w-full flex justify-center'>
                            <button onClick={togglePopup} className=' px-4 mt-2 rounded-lg cursor-pointer h-100 bg-orange-600 text-white '> view Details </button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

const ViwePopup = ({ isOpen, setIsOpen, donation, }) => {
    // console.log(popupData)
    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        // Add donation listener when component mounts
        if (isOpen) {
            document.body.style.overflow = 'hidden'; // Prevent scrolling on the background page
        }

        // Remove donation listener when component unmounts
        return () => {
            document.body.style.overflow = 'visible'; // Re-enable scrolling on the background page
        };
    }, [isOpen]);

    return (
        <>
            {isOpen && (
                <div className="fixed top-0 left-0 flex items-center px-2 justify-center w-full h-full bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded shadow-2xl w-full  md:w-96  overflow-y-auto">
                        <div className='  min-w-[330px]     border-r-5 border   shadow-2xl bg-white text-black  ' >
                            <div className={`membercardHeadin bg-[#1E3A8A]     text-center text-white font-bold `}>
                                {donation.donarName}
                            </div>
                            <div className="p-2 flex justify-center flex-col ">
                                <div className=" flex gap-3  ">
                                    <img className=" w-14 h-14 ring-2 ring-orange-400    flex-none rounded-full " src={`${Domain + donation.donarPhoto.replace(" ", "%20")}`} alt="" loading="lazy" />

                                    <div className="flex min-w-0 gap-x-4 items-center ">
                                        {/* <div className='border-2 p-[0.5px] mt-3 border-orange-500 rounded-full  '> */}
                                        {/* </div> */}
                                        <div className="min-w-0 flex-auto font-extrabold leading-6 ">
                                            {/* <p className="text-[17px] ms-6 font-extrabold  " >  </p> */}
                                            <p className="text-[15px] flex  font-bold tracking-tight text-gray-600">
                                                <span className=' w-[65px] me-2 flex justify-between'>तिथि  <span className=' ms-2'>: </span> </span>
                                                {new Date(donation?.entryDatetime).toDateString()}
                                            </p>
                                            <p className="text-[15px] flex text-start font-bold tracking-tight text-gray-600">
                                                <span className='w-[65px] me-2 flex justify-between'>दान श्रेणी <span>:</span></span>
                                                {donation.donationCategory.join(', ').replace(/[^\w\s,]/g, '')}
                                            </p>



                                            {/* <p className="text-[15px]  flex text-start  font-bold tracking-tight text-gray-600">
                                                <span className=' w-[60px] me-4 flex justify-between'>जानकारी <span className=' ms-2' >:</span></span>
                                                {donation.message}
                                            </p> */}

                                            {/* <p className="text-[15px] flex text-start  font-bold tracking-tight text-gray-600">
                                                <span className=' w-[75px] me-2 flex justify-between'>स्थान <span className=' ms-2' >:</span></span>
                                                {donation.placeLocation}
                                            </p> */}
                                            {/* <p className="text-[13px] flex  font-bold tracking-tight text-gray-600"><span className=' w-[50px] me-2 flex justify-between'> व्यवसाय <span>: </span> </span> बिजनेस </p> */}
                                            <div className=' w-full justify-around flex mt-10'>
                                                <img className=" w-14 h-14 ring-2     flex-none  " src={`${Domain + donation?.eventPhoto1?.replace(" ", "%20")}`} alt="" loading="lazy" />

                                                <img className=" w-14 h-14 ring-2     flex-none " src={`${Domain + donation?.eventPhoto2?.replace(" ", "%20")}`} alt="" loading="lazy" />


                                            </div>
                                        </div>


                                    </div>


                                    {/* <div className='flex justify-center bg-gray-200 items-end gap-3 mt-4'>
                <p className='flex flex-col items-center cursor-pointer ' onClick={() => window.location.href = `tel:${9827033232}`}> <img className='h-8' src={callporwal} alt="Call" loading="lazy" /> <span className='text-[12px] leading-7 font-bold tracking-tight text-gray-900'>Call</span></p>
                <p className='flex flex-col items-center cursor-pointer' onClick={() => window.location.href = `whatsapp://send?phone=${9827033232}`}><img className='h-8' src={chatporwal} alt="Chat" loading="lazy" /> <span className='text-[12px]  leading-7 font-bold tracking-tight text-gray-900'>Chat</span></p>
                <p className='flex flex-col items-center cursor-pointer' onClick={() => window.location.href = `sms:${9827033232}`}> <img className='h-8' src={messageporwal} alt="Message" loading="lazy" /><span className='text-[12px]  leading-7 font-bold tracking-tight text-gray-900'> Message</span></p>
                <p className='flex flex-col items-center cursor-pointer' onClick={togglePopup}> <img className='h-8' src={viewporwal} alt="View" loading="lazy" /><span className='text-[12px]  leading-7 font-bold tracking-tight text-gray-900'> View</span></p>
            </div> */}
                                    {/* Online indicator */}
                                    {/* <div className="h-3 w-3 bg-green-400 rounded-full"></div> */}

                                </div>

                            </div>
                        </div>

                        <div className="w-full flex justify-center mt-auto"> {/* mt-auto will push the button to the bottom */}
                            <button
                                className="mt-4 bg-[#172553] hover:bg-blue-700 text-white font-bold py-2 px-10 rounded-full"
                                onClick={togglePopup}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>

            )}

        </>
    );
};
